module.exports = __webpack_public_path__ + "img/arrows-circle-arrow-bottom.23a6b97d.svg";